<script>
    import Table from "../Table.svelte";
    import { onDestroy, onMount } from "svelte";
    import { navigate } from "svelte-routing";
    import { queryParams } from "../../../stores/settingsStore";
    import { selectedActiveYear } from "../../../stores/selectedActiveYear";
    import { filterDefinedValues } from "../../../utils/filterDefinedValues";
    import { addStringSort, createColumnsFromQuery, removeFilterFromKeys } from "../../../utils/sortFunction";
    import MembershipPrintCard from "./MembershipPrintCard.svelte";
    import { mpTableFilter } from "../../../stores/membershipPrintTableFilterStore";
    import { getMembershipPrints } from "../../../services/membershipPrintService"
    import MembershipPrintSearchSection from "../../SearchBars/MembershipPrintSearchSection.svelte";
    import Button from "../../Button/Button.svelte";
    import toast from "svelte-french-toast";

    let totalPages;
    let membershipPrints = [];
    let totalCount;
    let isLoading;
    let columns = [
        { displayName: " ", fieldName: "" },
        { displayName: "Codice", fieldName: "code", isSortable: true, sortValue: "" },
        { displayName: "Data", fieldName: "date", isSortable: true, sortValue: "asc" },
        { displayName: "Note", fieldName: "notes" },
    ];

    async function getMembershipPrintList(pagination) {
        isLoading = true;

        getMembershipPrints(pagination).then((resp) => {
            if(resp.status === 200 && resp?.data) {
                membershipPrints = resp.data.data;
                totalPages = Math.ceil(resp.data?.totalCount / $mpTableFilter.size);
                totalCount = resp.data.totalCount;
            }
            isLoading = false;
        }).catch((err) => {
            isLoading = false;

            if(err?.response?.data?.status === 500) {
                toast.error(`Errore durante la ricerca, errore: ${err.toString()}`);
            }
        })
    }

    function updateSortFilter(sorts) {
        let filteredSorts = removeFilterFromKeys($mpTableFilter?.sort ?? "", columns.map((c) => c.fieldName));

        sorts.forEach(sort => {
            filteredSorts = addStringSort(filteredSorts, sort.field, sort.sort);
        });

        $mpTableFilter = { ...$mpTableFilter, sort: filteredSorts};
    }

    const unsubscribeQueryParams = queryParams.subscribe(q => {
        const filters = Object.fromEntries(q);

        if (!filters.page) {  filters.page = "1" }
        if (!filters.size) {  filters.size = "50" }
        if (!!filters.year) {
            $selectedActiveYear = +filters.year;
        }

        if (!!filters.sort) {
            columns = createColumnsFromQuery(filters.sort, columns);
        }

        $mpTableFilter = { ...filters };
    });

    const unsubscribeTableFilter = mpTableFilter.subscribe(async (filter) => {
        if (!filter) {
            return;
        }

        const urlSearchParams = new URLSearchParams(filterDefinedValues(filter));
        navigate(!urlSearchParams.size ? "" : `?${urlSearchParams.toString()}`, {replace: false});

        if (!!filter.year) {
            $selectedActiveYear = +filter.year;
            getMembershipPrintList(Object.fromEntries(urlSearchParams));
        }

    });

    let unsubscribeActiveYear;

    onMount(() => {
        unsubscribeActiveYear = selectedActiveYear.subscribe((year) => {
            $mpTableFilter = { ...$mpTableFilter, year };
        });
    })

    onDestroy(() => {
        unsubscribeQueryParams();
        unsubscribeTableFilter();
        unsubscribeActiveYear();

        $mpTableFilter = null;
    });
</script>

<Table
    bind:page={$mpTableFilter.page}
    bind:size={$mpTableFilter.size}
    bind:rowCount={membershipPrints.length}
    bind:totalPages
    bind:totalCount
    bind:isLoading
    columns={columns}
    subject="Stampe"
    on:sort={(e) => updateSortFilter(e.detail)}
>
    <div class="flex gap-2 flex-col md:flex-row justify-between w-full" slot="actions">
        <div class="relative w-full max-w-full font-semibold text-3xl flex-grow flex-1">
            Stampe
        </div>

        <Button
            handleClick="{() => navigate(`create?referenceYear=${$selectedActiveYear}`, {replace: true})}"
            buttonClass="w-full md:w-44 bg-lightBlue-500 text-white"
            content="Crea stampa"
        />
    </div>

    <div slot="searchbar" class="z-40">
        <MembershipPrintSearchSection />
    </div>

    <svelte:fragment slot="tableContent">
        {#each membershipPrints as mb}
            <MembershipPrintCard
                bind:membershipPrint="{mb}"
            />
        {/each}
    </svelte:fragment>
</Table>